export var formatCount = function (value) {
    var amount = Number(value);
    if (!Number.isFinite(amount))
        return '—';
    return new Intl.NumberFormat(undefined, { maximumFractionDigits: 2 }).format(amount);
};
export var formatPercent = function (value) {
    if (!Number.isFinite(value))
        return '—';
    return "".concat(new Intl.NumberFormat(undefined, { maximumFractionDigits: 1 }).format(value), "%");
};
export var shareOf = function (part, total) { return (total ? (part / total) * 100 : 0); };
